module.exports = __webpack_public_path__ + "static/media/T13.820bbaf1.jpg";